import { PagingRequest } from '../common/paging';
import {TenderType} from './tender.enums';
import {Configuration} from '../../configuration';
import { NoticeStatus } from '../notices/notice.enums';

export class MatchingTenderSearchRequest extends PagingRequest {
    supplierId: number;
    deadlineDateFrom: string;
    deadlineDateTo: string;
    types: Array<TenderType>;
    noticeId: number;
    excludeBookmarked: boolean;
    excludeViewed: boolean;
    excludeAssigned: boolean;

    constructor(configuration: Configuration) {
        super(configuration);

        this.types = [TenderType.Low, TenderType.High, TenderType.PrivateB2B, TenderType.PrivateProject, TenderType.PinHigh, TenderType.PinLow];
        this.excludeBookmarked = false;
        this.excludeViewed = false;
        this.excludeAssigned = false;
    }
}

export class MatchingTenderSummaryDto {
    id: number;
    title: string;
    b2BRef: number;
    type: string;
    location: string;
    jsInterestDeadlineDate: string;
    jsInterestDeadlineTime: string;
    remainingDaysToRegisterInterest: number;
    jsDocumentSubmissionDate: string;
    jsDocumentSubmissionTime: string;
    jsEstimatedPublication: string;
    remainingDaysToSubmitDocument: number;
    description: string;
    aiVagueDescription: string;
    bookmarked: boolean;
    bookmarkedById: number;
    bookmarkedBy: string;
    jsBookmarkedDate: string;
    assigned: boolean;
    assignedToId: number;
    assignedTo: string;
}

export class CheckTenderDto {
    isValid: boolean;
    errorDetail: string;
    noticeStatus: NoticeStatus;
}

export class RemoveMatchDto {
    matchingTenderId: number;
}

export class RemoveMatchesDto {
    matches: Array<RemoveMatchDto>;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/tenders/matching.tender.models.ts